// 配置项

// const host = 'https://culture.aqitai.com/'
const host = 'https://culture.aqitai.com/'
const fileHost = 'https://culture.aqitai.com/api/user/v1/upload'

const config = {
    host, fileHost
}

export default config
